import { render, staticRenderFns } from "./DiscoverLoyaltyProducts.vue?vue&type=template&id=4f757b50&scoped=true&"
import script from "./DiscoverLoyaltyProducts.vue?vue&type=script&lang=js&"
export * from "./DiscoverLoyaltyProducts.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverLoyaltyProducts.vue?vue&type=style&index=0&id=4f757b50&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f757b50",
  null
  
)

export default component.exports